export default __webpack_public_path__ + "static/media/ice-crystals.75c984d5.jpg";